export default "__VITE_ASSET__a5359aad__"